<template>
  <batch-upload-file lob="SE" />
</template>

<script>
import batchUploadFile from '@/components/Cargo/FileUpload/batchUploadFile'
export default {
  name: 'SEBatchUploadFile',
  components: { batchUploadFile }
}
</script>

<style scoped>

</style>
